function updateCartCount(count) {
  document.querySelectorAll(".cart-count").forEach((el) => (el.textContent = count));
}

/* ---------- Added-to-cart drawer ---------- */
(function () {
  var LOCALE = (document.documentElement.lang || (window.Shopify && window.Shopify.locale) || "en").slice(0, 2).toLowerCase();
  // Locale root ("/" or "/de/"): cart calls made through it return translated product titles
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  if (ROOT.charAt(ROOT.length - 1) !== "/") ROOT += "/";
  var FREE_SHIPPING_CENTS = 3900;
  // pickup is fixed theme copy with markup (not product data), so it is inserted as HTML
  var T = LOCALE === "de" ? {
    added: "In den Warenkorb gelegt",
    viewCart: "Warenkorb ansehen",
    checkout: "Zur Kasse",
    away: "Noch {amount} bis zum Gratisversand",
    unlocked: "Du hast Gratisversand",
    pickup: "Oder <strong>gratis abholen</strong> in der Shopping City Seiersberg – meist in 2 Stunden bereit (während der Öffnungszeiten: Mo–Fr 9:00–19:30, Sa 9:00–18:00).",
    close: "Schließen",
    error: "Der Artikel konnte nicht hinzugefügt werden.",
    qty: "Menge",
    qtyMinus: "Menge verringern",
    qtyPlus: "Menge erhöhen",
    noMore: "Mehr ist leider nicht auf Lager.",
    remove: "Entfernen",
    removed: "Artikel entfernt",
    removedNote: "Der Artikel wurde aus dem Warenkorb entfernt.",
    empty: "Dein Warenkorb ist leer.",
    error2: "Das hat leider nicht geklappt. Bitte versuche es noch einmal."
  } : {
    added: "Added to cart",
    viewCart: "View cart",
    checkout: "Checkout",
    away: "You're {amount} away from free shipping",
    unlocked: "You've got free shipping",
    pickup: "Or <strong>pick up for free</strong> at Shopping City Seiersberg – usually ready within 2 hours (during opening hours: Mon–Fri 9:00–19:30, Sat 9:00–18:00).",
    close: "Close",
    error: "The item could not be added.",
    qty: "Quantity",
    qtyMinus: "Decrease quantity",
    qtyPlus: "Increase quantity",
    noMore: "Sorry, there is no more in stock.",
    remove: "Remove",
    removed: "Item removed",
    removedNote: "The item was removed from your cart.",
    empty: "Your cart is empty.",
    error2: "That did not work. Please try again."
  };
  var STORE_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 10v10h16V10"/><path d="M2.5 10 5 4h14l2.5 6z"/><path d="M10 20v-5h4v5"/></svg>';

  // Same output as the shop's money format, e.g. "€12,40"
  function money(cents) {
    var parts = (Math.abs(cents) / 100).toFixed(2).split(".");
    return (cents < 0 ? "-" : "") + "€" + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + parts[1];
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // Styles for the quantity stepper in the drawer (kept here so the drawer markup and its look stay in one file)
  function ensureDrawerStyles() {
    if (document.getElementById("nobi-drawer-qty-style")) return;
    var css =
      ".nobi-drawer-qty{display:inline-flex;align-items:stretch;margin-top:12px;border:2px solid #23211C;border-radius:8px;overflow:hidden;background:#fff}" +
      ".nobi-qty-btn{width:46px;height:44px;padding:0;border:0;background:#fff;color:#23211C;font-size:26px;font-weight:700;line-height:1;cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent}" +
      ".nobi-qty-btn:active:not(:disabled){background:#23211C;color:#fff}" +
      ".nobi-qty-btn:disabled{color:#23211C;cursor:default}" +
      ".nobi-qty-val{min-width:52px;display:flex;align-items:center;justify-content:center;font-size:20px;font-weight:700;color:#23211C;border-left:2px solid #23211C;border-right:2px solid #23211C}" +
      ".nobi-drawer-qty-msg{margin-top:8px;color:#B3261E;font-size:14px;font-weight:700;line-height:1.4}" +
      ".nobi-drawer-qty-msg:empty{display:none}" +
      ".nobi-drawer-remove{display:block;margin-top:12px;padding:6px 0;border:0;background:none;color:#23211C;font:inherit;font-size:15px;font-weight:700;text-decoration:underline;text-underline-offset:3px;cursor:pointer;touch-action:manipulation}" +
      ".nobi-drawer-remove:disabled{cursor:wait}";
    var st = document.createElement("style");
    st.id = "nobi-drawer-qty-style";
    st.textContent = css;
    document.head.appendChild(st);
  }

  function ensureDrawer() {
    ensureDrawerStyles();
    if (document.getElementById("nobi-drawer")) return;
    var html =
      '<div class="nobi-drawer-overlay" id="nobi-drawer-overlay"></div>' +
      '<aside class="nobi-drawer" id="nobi-drawer" role="dialog" aria-modal="true" aria-labelledby="nobi-drawer-title" tabindex="-1">' +
      '  <div class="nobi-drawer-head">' +
      '    <h2 id="nobi-drawer-title">' + esc(T.added) + "</h2>" +
      '    <button type="button" class="nobi-drawer-close" id="nobi-drawer-close" aria-label="' + esc(T.close) + '">&times;</button>' +
      "  </div>" +
      '  <div class="nobi-drawer-item" id="nobi-drawer-item"></div>' +
      "  <div>" +
      '    <a class="nobi-drawer-btn" id="nobi-drawer-viewcart" href="' + esc(ROOT + "cart") + '">' + esc(T.viewCart) + "</a>" +
      '    <a class="nobi-drawer-btn solid" id="nobi-drawer-checkout" href="' + esc(ROOT + "checkout") + '">' + esc(T.checkout) + "</a>" +
      "  </div>" +
      '  <div class="nobi-drawer-ship">' +
      '    <div id="nobi-drawer-ship-text"></div>' +
      '    <div class="nobi-drawer-bar" aria-hidden="true"><span id="nobi-drawer-bar-fill"></span></div>' +
      "  </div>" +
      '  <p class="nobi-pickup">' + STORE_ICON + "<span>" + T.pickup + "</span></p>" +
      "</aside>";
    document.body.insertAdjacentHTML("beforeend", html);
    document.getElementById("nobi-drawer-close").addEventListener("click", closeDrawer);
    document.getElementById("nobi-drawer-overlay").addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });
  }

  function closeDrawer() {
    document.body.classList.remove("nobi-drawer-open");
  }

  // The matching line from cart.js carries discounts calculated on the whole cart (e.g. 2+1 masks)
  function findLine(cart, item) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (item && item.key && items[i].key === item.key) return items[i];
    }
    return null;
  }

  function discountLines(line) {
    var allocs = line.line_level_discount_allocations;
    var out = "";
    if (allocs && allocs.length) {
      for (var i = 0; i < allocs.length; i++) {
        var a = allocs[i] || {};
        var title = a.discount_application && a.discount_application.title;
        if (title && a.amount > 0) out += '<div class="nobi-drawer-disc">' + esc(title) + ": &minus;" + money(a.amount) + "</div>";
      }
    } else if (line.discounts && line.discounts.length) {
      for (var j = 0; j < line.discounts.length; j++) {
        var d = line.discounts[j] || {};
        if (d.title && d.amount > 0) out += '<div class="nobi-drawer-disc">' + esc(d.title) + ": &minus;" + money(d.amount) + "</div>";
      }
    }
    return out;
  }

  // The line shown in the drawer: its quantity can be changed with − / + (cart/change.js on the line key)
  var drawerItem = null;
  var drawerLineKey = null;

  function stepperHtml(qty) {
    return (
      '<div class="nobi-drawer-qty" role="group" aria-label="' + esc(T.qty) + '">' +
      '<button type="button" class="nobi-qty-btn" data-drawer-qty="-1"' + (qty <= 1 ? " disabled" : "") + ' aria-label="' + esc(T.qtyMinus) + '">&minus;</button>' +
      '<span class="nobi-qty-val" id="nobi-drawer-qty-val" aria-live="polite">' + qty + "</span>" +
      '<button type="button" class="nobi-qty-btn" data-drawer-qty="1" aria-label="' + esc(T.qtyPlus) + '">+</button>' +
      "</div>" +
      '<div class="nobi-drawer-qty-msg" id="nobi-drawer-qty-msg" role="alert"></div>'
    );
  }

  function openDrawer(item, cart) {
    ensureDrawer();
    drawerItem = item || {};
    renderDrawer(drawerItem, cart || {}, true);
  }

  function renderDrawer(item, cart, opening) {
    var line = findLine(cart, item) || item;
    drawerLineKey = line.key || item.key || null;
    var title = line.product_title || item.product_title || "";
    var image = line.image || item.image || "";
    var imgUrl = image ? image + (image.indexOf("?") >= 0 ? "&" : "?") + "width=300" : "";
    var img = imgUrl
      ? '<img src="' + esc(imgUrl) + '" alt="' + esc(title) + '" width="130" height="130">'
      : "<span>" + esc((title || "?").charAt(0)) + "</span>";
    // Regular unit price; applied discounts are listed by name underneath
    var unit = typeof line.original_price === "number" ? line.original_price : line.price;
    var unitFinal = typeof line.final_price === "number" ? line.final_price : unit;
    var discHtml = discountLines(line);
    var priceHtml = "";
    if (typeof unit === "number") {
      priceHtml = !discHtml && unitFinal < unit ? "<s>" + money(unit) + "</s>" + money(unitFinal) : money(unit);
    }
    document.getElementById("nobi-drawer-title").textContent = T.added;
    document.getElementById("nobi-drawer-item").innerHTML =
      '<div class="nobi-drawer-img">' + img + "</div>" +
      '<div class="nobi-drawer-info">' +
      '  <div class="nobi-drawer-title">' + esc(title) + "</div>" +
      (priceHtml ? '  <div class="nobi-drawer-price">' + priceHtml + "</div>" : "") +
      discHtml +
      stepperHtml(line.quantity || 1) +
      '<button type="button" class="nobi-drawer-remove" data-drawer-remove>' + esc(T.remove) + "</button>" +
      "</div>";
    updateDrawerTotals(cart, opening);
    if (opening) {
      document.body.classList.add("nobi-drawer-open");
      document.getElementById("nobi-drawer").focus({ preventScroll: true });
    }
  }

  // Cart count on the "view cart" button, free-shipping text and progress bar
  function updateDrawerTotals(cart, fromZero) {
    document.getElementById("nobi-drawer-viewcart").textContent =
      T.viewCart + (typeof cart.item_count === "number" ? " (" + cart.item_count + ")" : "");
    var checkout = document.getElementById("nobi-drawer-checkout");
    if (checkout) checkout.style.display = cart.item_count === 0 ? "none" : "";
    var total = typeof cart.total_price === "number" ? cart.total_price : 0;
    var remaining = FREE_SHIPPING_CENTS - total;
    var shipEl = document.getElementById("nobi-drawer-ship-text");
    if (remaining > 0) {
      shipEl.innerHTML = esc(T.away).replace("{amount}", "<strong>" + money(remaining) + "</strong>");
    } else {
      shipEl.innerHTML = "<strong>" + esc(T.unlocked) + "</strong>";
    }
    var pct = Math.max(0, Math.min(100, Math.round((total / FREE_SHIPPING_CENTS) * 100)));
    var fill = document.getElementById("nobi-drawer-bar-fill");
    if (fromZero) fill.style.width = "0%";
    setTimeout(function () { fill.style.width = pct + "%"; }, 30);
  }

  function changeLine(quantity) {
    return fetch(ROOT + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: drawerLineKey, quantity: quantity })
    }).then(function (res) {
      return res.json().then(function (j) { if (!res.ok || j.status) throw j; return j; });
    });
  }

  // While a request runs every button waits; afterwards "−" stays inactive at quantity 1
  function setStepperBusy(busy) {
    var valEl = document.getElementById("nobi-drawer-qty-val");
    var qty = valEl ? parseInt(valEl.textContent, 10) || 1 : 1;
    var btns = document.querySelectorAll("#nobi-drawer .nobi-qty-btn, #nobi-drawer .nobi-drawer-remove");
    for (var i = 0; i < btns.length; i++) {
      var isMinus = btns[i].getAttribute("data-drawer-qty") === "-1";
      btns[i].disabled = busy || (isMinus && qty <= 1);
    }
  }

  // − / + and "remove" in the drawer
  document.addEventListener("click", function (e) {
    var stepBtn = e.target.closest("[data-drawer-qty]");
    var rmBtn = e.target.closest("[data-drawer-remove]");
    if ((!stepBtn && !rmBtn) || !drawerLineKey) return;
    e.preventDefault();
    var msg = document.getElementById("nobi-drawer-qty-msg");
    if (msg) msg.textContent = "";
    if (rmBtn) {
      setStepperBusy(true);
      changeLine(0)
        .then(function (cart) {
          updateCartCount(cart.item_count);
          drawerLineKey = null;
          document.getElementById("nobi-drawer-title").textContent = T.removed;
          document.getElementById("nobi-drawer-item").innerHTML =
            '<div class="nobi-drawer-info"><div class="nobi-drawer-title">' +
            esc(cart.item_count === 0 ? T.empty : T.removedNote) + "</div></div>";
          updateDrawerTotals(cart, false);
        })
        .catch(function () { setStepperBusy(false); if (msg) msg.textContent = T.error2; });
      return;
    }
    var valEl = document.getElementById("nobi-drawer-qty-val");
    var cur = parseInt(valEl.textContent, 10) || 1;
    var next = cur + parseInt(stepBtn.getAttribute("data-drawer-qty"), 10);
    if (next < 1) return;
    setStepperBusy(true);
    changeLine(next)
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderDrawer(drawerItem, cart, false);
        var line = findLine(cart, { key: drawerLineKey });
        if (line && line.quantity < next) {
          var m = document.getElementById("nobi-drawer-qty-msg");
          if (m) m.textContent = T.noMore;
        }
      })
      .catch(function () {
        // e.g. not enough stock: show the real cart state and say why
        fetch(ROOT + "cart.js", { headers: { "Accept": "application/json" } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            renderDrawer(drawerItem, cart, false);
            var m = document.getElementById("nobi-drawer-qty-msg");
            if (m) m.textContent = T.noMore;
          })
          .catch(function () { setStepperBusy(false); });
      });
  });

  function afterAdd(item) {
    if (!item || item.status) throw item;
    return fetch(ROOT + "cart.js", { headers: { "Accept": "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        openDrawer(item, cart);
        return cart;
      });
  }

  function addByVariant(variantId, quantity) {
    return fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (res) { return res.json(); })
      .then(afterAdd);
  }

  function addByForm(form) {
    return fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: new FormData(form)
    })
      .then(function (res) { return res.json(); })
      .then(afterAdd);
  }

  window.nobiCart = { add: addByVariant, addForm: addByForm, open: openDrawer, close: closeDrawer };

  // Quick add on product cards
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-quick-add-variant]");
    if (!btn) return;
    e.preventDefault();
    var original = btn.textContent;
    btn.disabled = true;
    addByVariant(btn.dataset.quickAddVariant, 1)
      .catch(function (err) {
        alert((err && err.description) || T.error);
      })
      .then(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });

  // Product page form
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute("action") || "";
    if (!/\/cart\/add(\b|$)/.test(action)) return;
    e.preventDefault();
    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    addByForm(form)
      .catch(function (err) {
        alert((err && err.description) || T.error);
      })
      .then(function () {
        if (submit) submit.disabled = false;
      });
  });
})();

document.addEventListener("click", (e) => {
  if (e.target.matches("[data-qty-plus]")) {
    const input = e.target.parentElement.querySelector("[data-qty-input]");
    input.value = parseInt(input.value || "1", 10) + 1;
  }
  if (e.target.matches("[data-qty-minus]")) {
    const input = e.target.parentElement.querySelector("[data-qty-input]");
    input.value = Math.max(1, parseInt(input.value || "1", 10) - 1);
  }
});

document.addEventListener("click", (e) => {
  const thumbBtn = e.target.closest(".detail-thumb-btn");
  if (!thumbBtn) return;
  document.querySelectorAll(".detail-thumb-btn").forEach((b) => b.classList.remove("active"));
  thumbBtn.classList.add("active");
  const mainImg = document.getElementById("detail-main-img");
  if (mainImg) mainImg.src = thumbBtn.dataset.full;
});
